
export const RULE_TYPE_DAILY_MAX_HOURS = { text: 'Carga horária máxima por dia', value: 'daily_max_hours' };
export const RULE_TYPE_WEEKLY_MAX_HOURS = { text: 'Carga horária máxima por semana', value: 'weekly_max_hours' };
export const RULE_TYPE_MONTHLY_MAX_HOURS = { text: 'Carga horária máxima por mês', value: 'monthly_max_hours' };
export const RULE_TYPE_MIN_HOURS_BETWEEN_SHIFTS = { text: 'Carga horária mínima entre plantões', value: 'min_hours_between_shifts' };
export const RULE_TYPE_MAX_CONSECUTIVE_WORK_DAYS = { text: 'Máximo de dias consecutivos de trabalho', value: 'max_consecutive_work_days' };

export const RULE_TYPES = [
  RULE_TYPE_DAILY_MAX_HOURS,
  RULE_TYPE_WEEKLY_MAX_HOURS,
  RULE_TYPE_MONTHLY_MAX_HOURS,
  RULE_TYPE_MIN_HOURS_BETWEEN_SHIFTS,
  RULE_TYPE_MAX_CONSECUTIVE_WORK_DAYS,
];

export const RULE_TYPE_LABELS = {
  [RULE_TYPE_DAILY_MAX_HOURS.value]: RULE_TYPE_DAILY_MAX_HOURS.text,
  [RULE_TYPE_WEEKLY_MAX_HOURS.value]: RULE_TYPE_WEEKLY_MAX_HOURS.text,
  [RULE_TYPE_MONTHLY_MAX_HOURS.value]: RULE_TYPE_MONTHLY_MAX_HOURS.text,
  [RULE_TYPE_MIN_HOURS_BETWEEN_SHIFTS.value]: RULE_TYPE_MIN_HOURS_BETWEEN_SHIFTS.text,
  [RULE_TYPE_MAX_CONSECUTIVE_WORK_DAYS.value]: RULE_TYPE_MAX_CONSECUTIVE_WORK_DAYS.text,
};

export const LEVEL_GROUP = { text: 'Grupo', value: 'group' };
export const LEVEL_SCALE = { text: 'Escala', value: 'scale' };
export const LEVEL_USER = { text: 'Usuário', value: 'user' };

export const LEVELS = [
  LEVEL_GROUP,
  LEVEL_SCALE,
  LEVEL_USER,
];

export const RULE_LEVEL_LABELS = {
  [LEVEL_GROUP.value]: LEVEL_GROUP.text,
  [LEVEL_SCALE.value]: LEVEL_SCALE.text,
  [LEVEL_USER.value]: LEVEL_USER.text,
};

export const ACTION_WARN = { text: "Alerta de violação", value: "warn" };
export const ACTION_BLOCK = { text: "Bloqueio da ação", value: "block" };

export const RULE_ACTION_LABELS = {
  [ACTION_WARN.value]: ACTION_WARN.text,
  [ACTION_BLOCK.value]: ACTION_BLOCK.text,
};

export const WORKING_HOUR_ACTIONS = [
  ACTION_WARN,
  ACTION_BLOCK,
];
